import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Layout from 'shared/layouts/containers/Main'
import { Button, Form, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import InputWrapper from 'shared/components/InputWrapper'
import resAddCustomer from './resolvers/resAddCustomer'
import useInit from './hooks/useInit'
import useFocusError from 'shared/hooks/useFocusError'
import prepareSubmitForm from 'shared/utils/prepareSubmitForm'
import submitForm from './utils/submitForm'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import useDynamicFilter from 'hooks/useDynamicFilter'
import SelectWrapper from 'shared/components/SelectWrapper'

const AddCustomer: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)
  const [states, setStates] = useState<any>([])
  const [allStates, setAllStates] = useState<any>(false)
  const [countries, setCountries] = useState<any>([])
  const [currentCountry, setCurrentCountry] = useState<any>(null)

  const { id } = useParams()

  const navigate = useNavigate()

  const {
    register,
    getValues,
    handleSubmit,
    setFocus,
    setError,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: resAddCustomer,
  })

  useInit({
    setDataLoaded,
    setShowOverlay,
    setStates,
    setAllStates,
    setCountries,
    setCurrentCountry,
  })

  useFocusError({
    errors,
    setFocus,
  })

  useDynamicFilter({
    allRows: allStates,
    setFilteredRows: setStates,
    filterColumnName: 'country_id',
    inputValue: currentCountry,
    setDefaultFormFieldValue: setValue,
    formFieldValueName: 'state',
    isFormFieldValueNameObject: true,
    currentFormValues: getValues(),
    identityColumnName: 'id',
  })

  return (
    <Layout 
      footerContent={<Footer />} 
      brandContent={getBrandContent()} 
      showMinimizedBarButton={true}
      showOverlay={showOverlay}
    >
      <Form
        onSubmit={handleSubmit((data) =>
          prepareSubmitForm({
            submitForm,
            navigate,
            data,
            setShowOverlay,
            setError,
            id,
            name: 'Customer',
            successNav: '/account',
          }),
        )}
        id='main-form'
      >
        <InputWrapper colAttributes={{ md: 12 }} label='Name' name='name' errors={errors}>
          <Form.Control type='text' {...register('name')} />
        </InputWrapper>

        <InputWrapper colAttributes={{ md: 12 }} label='City' name='city' errors={errors}>
          <Form.Control type='text' {...register('city')} />
        </InputWrapper>

        <InputWrapper colAttributes={{ md: 12 }} label='Country' name='country' errors={errors}>
          <SelectWrapper
            name='country'
            control={control}
            options={countries}
            optionLabel='name'
            optionValue='id'
            placeholder='Select Country...'
            onChange={(option) => setCurrentCountry(option?.id)}
          />
        </InputWrapper>

        <InputWrapper
          colAttributes={{ md: 12 }}
          label='State/Province'
          name='state'
          errors={errors}
        >
          <SelectWrapper
            name='state'
            control={control}
            options={states}
            optionLabel='name'
            optionValue='id'
            placeholder='Select State...'
          />
        </InputWrapper>

        <Row>
          <div className='update ml-auto mr-auto'>
            <Button disabled={!dataLoaded} type='submit' className='btn-round btn-primary'>
              Submit
            </Button>
          </div>
        </Row>
      </Form>
    </Layout>
  )
}

export default AddCustomer
